export default "__VITE_ASSET__CM5hL_SU__"